import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as gatewayAndPriceListWhatsappActions from "../actions/gateway_and_price_list_whatsapp_actions";
import * as gatewayAndPriceListWhatsappTypes from "../types/gateway_and_price_list_whatsapp_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfGatewayAndPriceWhatsapp(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_GATEWAY_AND_PRICE_WHATSAPP, action.payload);
    if (res.status === 200) {
      yield put(gatewayAndPriceListWhatsappActions.getListOfGatewayAndPriceWhatsappSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListWhatsappActions.getListOfGatewayAndPriceWhatsappError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListWhatsappActions.getListOfGatewayAndPriceWhatsappError(e));
  }
}

function* getListOfWhatsappPrice2(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_WHATSAPP_PRICE_2, action.payload);
    if (res.status === 200) {
      yield put(gatewayAndPriceListWhatsappActions.getListOfWhatsappPrice2Success(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListWhatsappActions.getListOfWhatsappPrice2Error(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListWhatsappActions.getListOfWhatsappPrice2Error(e));
  }
}

function* editWhatsappPrice2(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_WHATSAPP_PRICE_2}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(gatewayAndPriceListWhatsappActions.editWhatsappPrice2Success(res.data));
      yield put(gatewayAndPriceListWhatsappActions.getListOfWhatsappPrice2Request(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListWhatsappActions.editWhatsappPrice2Error(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListWhatsappActions.editWhatsappPrice2Error(e));
  }
}


export default function* gatewayAndPriceListWhatsappSaga() {
  yield takeLatest(gatewayAndPriceListWhatsappTypes.getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_REQUEST, getListOfGatewayAndPriceWhatsapp);
  yield takeLatest(gatewayAndPriceListWhatsappTypes.getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_REQUEST, getListOfWhatsappPrice2);
  yield takeLatest(gatewayAndPriceListWhatsappTypes.editWhatsappPrice2.EDIT_WHATSAPP_PRICE_2_REQUEST, editWhatsappPrice2);
}
